/**
 * @generated SignedSource<<6c76fed1cd91ee9b7df046b7fa9db63a>>
 * @relayHash 559bd430fdfdfbcc11a49c9267441232
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 81d16e5819097691085dd475dbd9bfc078e336858a9f76b272264c34e97c1872

import type { ConcreteRequest } from 'relay-runtime';
export type SpaceStarMenuItemIsSpaceFavouritedQuery$variables = {
  spaceKey: string;
};
export type SpaceStarMenuItemIsSpaceFavouritedQuery$data = {
  readonly space: {
    readonly alias: string | null;
    readonly currentUser: {
      readonly isFavourited: boolean;
    };
    readonly id: string | null;
    readonly key: string | null;
    readonly name: string | null;
  } | null;
};
export type SpaceStarMenuItemIsSpaceFavouritedQuery = {
  response: SpaceStarMenuItemIsSpaceFavouritedQuery$data;
  variables: SpaceStarMenuItemIsSpaceFavouritedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "alias"
      },
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "concreteType": "SpaceUserMetadata",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isFavourited"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SpaceStarMenuItemIsSpaceFavouritedQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpaceStarMenuItemIsSpaceFavouritedQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "559bd430fdfdfbcc11a49c9267441232",
    "id": "81d16e5819097691085dd475dbd9bfc078e336858a9f76b272264c34e97c1872",
    "metadata": {},
    "name": "SpaceStarMenuItemIsSpaceFavouritedQuery",
    "operationKind": "query",
    "text": "query SpaceStarMenuItemIsSpaceFavouritedQuery($spaceKey:String!){space(key:$spaceKey){id,alias,name,key,currentUser{isFavourited}}}"
  }
};
})();

(node as any).hash = "c77a49dbb962e7ad6bf61d5e4f25b221";

export default node;
